import React from "react";
import { useLabels } from "../../../hooks/useLabels";
import { Checkbox } from "../../checkbox";
import { labels } from "./labels";
import { useUserDateDialogActions, useUserDateDialogState } from "./use-user-date-dialog-state";

export const SpecialDayList = () => {
	const { specialDays } = useUserDateDialogState();

	const { updateSpecialDays } = useUserDateDialogActions();

	const [[flagDayLabel, holidayLabel, nameDayLabel]] = useLabels([
		labels.specialDays.FlagDay,
		labels.specialDays.Holiday,
		labels.specialDays.NameDay,
	]);

	const inputLabels: Record<string, string> = {
		FlagDay: flagDayLabel,
		Holiday: holidayLabel,
		NameDay: nameDayLabel,
	};

	return specialDays ? (
		<div className="special-day-list">
			{Array.from(specialDays.entries()).map(([key, value]) => {
				return (
					<Checkbox
						key={key}
						id={key}
						checked={value}
						label={inputLabels[key]}
						onChange={(e) =>
							updateSpecialDays([
								{
									key: key as "Holiday" | "NameDay" | "FlagDay",
									show: e.currentTarget.checked,
								},
							])
						}
					/>
				);
			})}
		</div>
	) : null;
};
